import { motion } from "framer-motion";
import { site } from "@/data/site";

const lineVar = {
    hidden: { y: "115%" },
    visible: (d) => ({
        y: 0,
        transition: { duration: 1.1, delay: d, ease: [0.16, 1, 0.3, 1] },
    }),
};

const fadeVar = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 1, delay: 0.8 } },
};

export default function Statement() {
    return (
        <motion.section
            id="statement"
            data-testid="statement-section"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            className="mx-auto flex min-h-[85vh] max-w-[1600px] flex-col justify-center px-5 py-24 sm:px-10"
        >
            <div className="overflow-hidden">
                <motion.p
                    variants={lineVar}
                    custom={0}
                    className="mb-6 font-mono text-[11px] uppercase tracking-[0.35em] text-[#A1A1AA]"
                >
                    Kreatives Design- & Mediengestaltungsstudio
                </motion.p>
            </div>
            <h1 className="font-display font-extrabold uppercase leading-[0.85] tracking-tighter">
                <div className="overflow-hidden">
                    <motion.span
                        variants={lineVar}
                        custom={0.1}
                        className="block text-[13vw] text-[#F4F4F0] sm:text-[12.5vw] lg:text-[12vw]"
                    >
                        BVISION
                    </motion.span>
                </div>
                <div className="overflow-hidden">
                    <motion.span
                        variants={lineVar}
                        custom={0.22}
                        className="text-stroke block text-[8.5vw] sm:text-[7vw] lg:text-[6vw]"
                    >
                        Designer Studio
                    </motion.span>
                </div>
            </h1>
            <div className="mt-10 overflow-hidden">
                <motion.p
                    variants={lineVar}
                    custom={0.4}
                    className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#A1A1AA] sm:text-xs"
                >
                    {site.disciplines.join(" · ")}
                </motion.p>
            </div>
            <div className="mt-3 overflow-hidden">
                <motion.p variants={lineVar} custom={0.52} className="text-base font-light text-[#F4F4F0]/90 sm:text-lg">
                    {site.heroClaim[0]}{" "}
                    <span className="text-[#E63946]">{site.heroClaim[1]}</span>
                </motion.p>
            </div>
            <motion.p
                variants={fadeVar}
                className="mt-16 border-t border-white/10 pt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-[#A1A1AA]"
            >
                Studio-Status — <span className="text-[#E63946]">Neue Projekte 2026</span>
            </motion.p>
        </motion.section>
    );
}
